import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'san-info-qrtne',
  templateUrl: './info-qrtne.component.html',
  styleUrls: ['./info-qrtne.component.scss'],
  standalone: false,
})
export class InfoQRTNEComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
